// opervex-frontend/src/components/CustomInput/customQuantity.js

import React from "react";
import { Form } from "react-bootstrap";
import { NumericFormat } from "react-number-format";

const customQuantity = ({ value, onChange, label, hidden, disabled, name, showDisabled, decimal }) => {
  return (
    <Form.Group>
      {label && <Form.Label>{label}</Form.Label>}
      {!showDisabled && disabled ? (
        <div>
          {new Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: decimal ?? 3,
            maximumFractionDigits: decimal ?? 3,
          }).format(value)}
        </div>
      ) : (
        <NumericFormat
          value={value}
          onValueChange={(values) => onChange(values.floatValue)}
          thousandSeparator="."
          decimalSeparator=","
          size="sm"
          decimalScale={decimal ?? 3}
          fixedDecimalScale
          name={name}
          hidden={hidden}
          disabled={disabled}
          customInput={Form.Control}
        />
      )}
    </Form.Group>
  );
};

export default customQuantity;
